export const MODAL_NAME = 'orders.confirm-selected-orders'
